import { useReadMonitorByIdQuery } from 'services/monitor'
import { MarketSpyGrid } from '../../presentationals/MarketSpyGrid'
import { useEffect, useState } from 'react'

interface MarketSpyContainerProps {
    marketSpyId?: number
}

export const MarketSpyContainer = (props: MarketSpyContainerProps): JSX.Element => {
    const {
        marketSpyId
    } = props

    const [readMonitorByIdQueryParams, setReadMonitorByIdQueryParams] = useState<any>(undefined)
    const [readMonitorByIdOptions, setReadMonitorByIdOptions] = useState<any>({
            skip: true
        }
    )

    const {
        data: readMonitorByIdQueryData,
        isLoading: readMonitorByIdQueryIsLoading
    } = useReadMonitorByIdQuery(readMonitorByIdQueryParams, readMonitorByIdOptions)

    useEffect(() => {
        setReadMonitorByIdQueryParams((prev: any) => {
            return {
                ...prev,
                monitorId: marketSpyId
            }
        })

        setReadMonitorByIdOptions((prev: any) => {
            return {
                ...prev,
                skip: marketSpyId === undefined
            }
        })
    }, [
        marketSpyId
    ])

    if (marketSpyId === undefined) {
        return (
            <></>
        )
    }

    return (
        <MarketSpyGrid
            marketSpy={readMonitorByIdQueryData}
        />
    )
}

